import { render, staticRenderFns } from "./AddProductsNew.vue?vue&type=template&id=64ce6f2c&scoped=true"
import script from "./AddProductsNew.vue?vue&type=script&lang=js"
export * from "./AddProductsNew.vue?vue&type=script&lang=js"
import style0 from "./AddProductsNew.vue?vue&type=style&index=0&id=64ce6f2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ce6f2c",
  null
  
)

export default component.exports